export default __webpack_public_path__ + "static/media/Repairability.06e270ba.svg";